export const SET_CONFIGS = "set_configs";
export const CHECK_DATA = "check_data";
export const GET_MILLS = "get_mills";
export const GET_MY_DATA = "mydata";
export const GET_DAMPERS = "damper_configs";
export const GET_BURNERS = "sub_configs";
